import { Component, Input } from '@angular/core';

export type StatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'error' | 'mint' | 'rose' | 'violet' | 'cyan' | 'orange';

@Component({
  standalone: false,
  selector: 'app-status-chip',
  template: `
    <span class="qira-chip" [attr.data-tone]="tone">
      <span *ngIf="dot" class="qira-chip__dot"></span>
      <ng-content></ng-content>
    </span>
  `,
  styles: [`
    :host { display: inline-flex; }
    .qira-chip {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 2px 10px;
      border-radius: var(--qira-radius-pill);
      background: color-mix(in srgb, var(--qira-on-surface) 8%, transparent);
      color: var(--qira-on-surface);
      font-size: 12px;
      font-weight: 700;
      line-height: 1.6;
      white-space: nowrap;
    }
    .qira-chip__dot {
      width: 6px; height: 6px;
      border-radius: 50%;
      background: currentColor;
      opacity: 0.75;
      flex: 0 0 auto;
    }
    .qira-chip[data-tone='success']  { background: color-mix(in srgb, var(--qira-success) 20%, transparent); color: color-mix(in srgb, var(--qira-success) 70%, var(--qira-on-surface)); }
    .qira-chip[data-tone='warning']  { background: color-mix(in srgb, var(--qira-warn) 20%, transparent);    color: color-mix(in srgb, var(--qira-warn) 70%, var(--qira-on-surface)); }
    .qira-chip[data-tone='error']    { background: color-mix(in srgb, var(--qira-error) 20%, transparent);   color: color-mix(in srgb, var(--qira-error) 70%, var(--qira-on-surface)); }
    .qira-chip[data-tone='info'],
    .qira-chip[data-tone='cyan']     { background: color-mix(in srgb, var(--qira-accent) 20%, transparent);  color: color-mix(in srgb, var(--qira-accent) 70%, var(--qira-on-surface)); }
    .qira-chip[data-tone='mint']     { background: color-mix(in srgb, var(--qira-mint) 22%, transparent);    color: color-mix(in srgb, var(--qira-mint) 55%, var(--qira-on-surface)); }
    .qira-chip[data-tone='rose']     { background: color-mix(in srgb, var(--qira-rose) 22%, transparent);    color: color-mix(in srgb, var(--qira-rose) 55%, var(--qira-on-surface)); }
    .qira-chip[data-tone='violet']   { background: color-mix(in srgb, var(--qira-violet) 22%, transparent);  color: color-mix(in srgb, var(--qira-violet) 65%, var(--qira-on-surface)); }
    .qira-chip[data-tone='orange']   { background: color-mix(in srgb, var(--qira-orange) 22%, transparent);  color: color-mix(in srgb, var(--qira-orange) 55%, var(--qira-on-surface)); }
    .qira-chip[data-tone='neutral']  { background: color-mix(in srgb, var(--qira-on-surface) 8%, transparent); color: var(--qira-on-surface-muted); }
  `]
})
export class StatusChipComponent {
  @Input() tone: StatusTone = 'neutral';
  @Input() dot = true;
}
